import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="max-w-screen-xl mx-auto px-4  lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Our Address Section */}
          <div>
            <h3 className="text-xl font-bold mb-4">Our Address</h3>
            <address className="not-italic">
              <p>68, Poorvi Marg, Block B</p>
              <p>New Delhi, India</p>
              <p>Postal Code 110057</p>
            </address>
          </div>

          {/* Contact Us Section */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
            <p className="mb-2">
              Phone:{" "}
              <a
                href="tel:+919871881251"
                className="hover:text-gray-400 transition duration-300 ease-in-out"
              >
                +91 987-188-1251
              </a>
            </p>
            <p>
              Email:{" "}
              <a
                href="mailto:gambianstudentsinindia@gmail.com"
                className="hover:text-gray-400 transition duration-300 ease-in-out"
              >
                gambianstudentsinindia@gmail.com
              </a>
            </p>
          </div>

          {/* Join Our Community Section */}
          <div>
            <h3 className="text-xl font-bold mb-4">Join Our Community</h3>
            <div className="flex space-x-4">
              {[
                {
                  name: "Facebook",
                  href: "https://www.facebook.com/gambianstudentsinindia/",
                  icon: "M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z",
                },
                {
                  name: "Instagram",
                  href: "https://www.instagram.com/gam_ind_association/",
                  icon: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z",
                },
                {
                  name: "Twitter",
                  href: "https://x.com/Gam_Ind_Assoc",
                  icon: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z",
                },
                {
                  name: "LinkedIn",
                  href: "https://www.linkedin.com/company/association-of-gambian-students-in-india/",
                  icon: "M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z",
                },
              ].map((social) => (
                <a
                  key={social.name}
                  target="_blank"
                  href={social.href}
                  className="bg-gray-700 hover:bg-gray-600 p-2 rounded-full transition duration-300 ease-in-out"
                  rel="noopener noreferrer"
                  aria-label={social.name}
                >
                  <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                    <path d={social.icon} />
                  </svg>
                </a>
              ))}
            </div>
          </div>
          {/* Quick Links Section */}
          <div>
            <h3 className="text-xl font-bold mb-2">Quick Links</h3>
            <nav>
              <ul className="space-y-2">
                {[
                  { name: "Home", path: "/" },
                  { name: "About", path: "/about" },
                  { name: "Events", path: "/events" },
                  { name: "Resources", path: "/resources" },
                  { name: "Members", path: "/members" }
                ].map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.path}
                      className="hover:text-gray-400 transition duration-300 ease-in-out"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="border-t border-gray-700 pt-8 mt-8 text-center">
          <p className="text-md text-gray-400 mb-2">
            &copy; {currentYear} Association of Gambian Students in India. All
            rights reserved.
          </p>
          <p className="text-sm text-gray-400">
            Made with <span className="text-red-500">❤️</span> by{" "}
            <a
              href="https://www.linkedin.com/in/mbsjallow/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300  hover:text-grey-700 transition duration-300 ease-in-out"
            >
              <strong><em>Muhammed S. Jallow</em></strong>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;